import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { useCallback, useMemo } from "react";

type ScoreButtonProps = {
  scoreOption: number;
  selectedScore: number | null;
  selectScore: (score: number) => void;
};

export default function ScoreButton({ scoreOption, selectedScore, selectScore }: ScoreButtonProps) {
  const selected = useMemo(() => selectedScore === scoreOption, [selectedScore, scoreOption]);

  const style: ThemeUIStyleObject = useMemo(
    () => ({
      height: 52,
      width: 52,
      borderRadius: "dt_radius_s",
      fontWeight: 800,
      fontSize: 18,
      textAlign: "center",
      display: "inline-block",
      margin: RAW_cssValue("5px 2px"),
      backgroundColor: selected ? "dt_background_accent" : "dt_background_tertiary",
      color: selected ? "dt_content_accent" : RAW_cssValue("#6E77C1"),
      border: selected ? "dt_active" : "dt_card",
    }),
    [selected],
  );

  const onClick = useCallback(() => selectScore(scoreOption), [selectScore, scoreOption]);

  return (
    <div sx={style} onClick={onClick}>
      <div sx={{ paddingTop: RAW_cssValue(10) }}>{scoreOption}</div>
    </div>
  );
}
